import { getBrowserDimensions } from '.././layout/layout.js';

let rowBankCount = 2;
let rowDisplayCount = 2;
let rowIndex = 0;

let section = document.querySelector('#exhibitions-inner');

const virtualTourRowsHtml = (rows) => {
    console.log('rows html');
    let html = '';
    const browserWidth = getBrowserDimensions('width');
    rows.forEach((row) => {
        let rowId = row.rowId;
        if(rowId <= rowDisplayCount && rowId > rowIndex){
        // only print rows that haven't been printed
            console.log(`row ${rowId}`);
            html = `<div class="virtual-tour-row"><div class="exhibitions-items">`;
            // exhibit html
            html += virtualTourExhibit(row,browserWidth);
            // close row
            html += `</div></div>`;
            
            // if row is below current maximum
            if(rowId <= rowDisplayCount){
                // current row counter
                rowIndex += 1;
                console.log(`rowIndex = ${rowIndex}`);
                // print to page
                section.innerHTML += html;
            }
        }
    });
}

const optimizeBrowserWidth = (img,browserWidth) => {
    let image;

    if (browserWidth > 0 && browserWidth < 641) {
        // mobile
        image = img.sizes['small-thumbnail'];
    } else if (browserWidth >= 640 && browserWidth < 813) {
        // tablet
        image = img.sizes.thumbnail;
    } else if (browserWidth >= 813 && browserWidth < 1367) {
        // small desktop
        image = img.sizes.medium;
    } else if (browserWidth >= 1367 && browserWidth < 1921) {
        // large desktop
        image = img.sizes.medium;
    } else {
        // largest
        image = img.sizes.medium;
    }

    return image;
}

const dynamicVirtualTourImgs = (img,exhibitWidth,browserWidth) => {
    let image;
    let imageDesktop = '';
    
    if (browserWidth > 0 && browserWidth < 641) {
        // mobile
        image = img.sizes['small-thumbnail'];
    } else if (browserWidth >= 640 && browserWidth < 813) {
        // tablet
        if(exhibitWidth == 'full'){
            image = img.sizes['medium'];
        } else {
            image = img.sizes['small-thumbnail'];
        }
    } else if (browserWidth >= 813) {
        // small desktop
        switch(exhibitWidth){
            case 'one-quarter':
                image = img.sizes['small-thumbnail'];
                imageDesktop = img.sizes['small-thumbnail'];
                break;
            case 'one-third':
                image = img.sizes['small-thumbnail'];
                imageDesktop = img.sizes['small-thumbnail'];
                break;
            case 'half-width':
                image = img.sizes['small-thumbnail'];
                imageDesktop = img.sizes['thumbnail'];
                break;
            case 'full':
                image = img.sizes['small-thumbnail'];
                imageDesktop = img.sizes['large'];
                break;
            default:
                image = img.url;
        }
    }

    let html = `
    <picture class="exhibition-image zoom-image">
        <source srcset="${imageDesktop}" media="(min-width: 768px)">
        <img src="${image}" alt="${img.alt}" loading="lazy">
    </picture>
    `;

    return html;
}

//const virtualTourExhibit = (row) => {
const virtualTourExhibit = (row,browserWidth) => {
    console.log('exhibits html');
    let exhibits = row.exhibits;
    let html = '';
    // build exhibit html within the row
    exhibits.forEach((x) => {
        html += `<a href="${x.url}" class="exhibition exhibition--${x.width}"`; 
        if(x.target == true){
            html += `target="_blank">`;
        } else {
            html += `>`;
        }
        html += `<span class="exhibition-box">`;
        if(x.img){
            let exhibitWidth = x.width;
            let img = dynamicVirtualTourImgs(x.img,exhibitWidth,browserWidth);
            html += img;
        }
        html += `<span class="exhibition-contents">`;
        html += `<span class="exhibition-info-box">`;
            if(x.status){
                html += `<h4 class="exhibition-schedule article-sub-heading">${x.status}</h4>`;
            }
            html += `<h3 class="exhibition-heading article-heading">${x.title}</h3><span class="exhibition-content body-copy">${x.content}</span>`;
            if(x.url){
                let copy;
                if(!x.button){
                    copy = 'Learn More';
                } else {
                    copy = x.button;
                }
                html += `<span target="_blank" class="exhibition-cta arrow-cta arrow-cta--blue">${copy}<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 570 1000"><polygon points="73 1000 0 927.3 424.8 500 0 72.7 73 0 570 500 "/></svg></span>`;
            }
        html += `</span>`;
        if(x.width == 'full'){
            html += `<div class="exhibition-content body-copy">${x.content}</div>`;
        }
        html += `</span></a>`;
    });
    return html;
}

const showHideLoadMore = count => {
    console.log('show/hide load more');
    let loadMore = document.querySelector('#virtual-tour-rows-cta-wrapper');
    if(loadMore){
        if(count > rowDisplayCount) {
            // more rows available, show button
            loadMore.classList.add('load_more--active');
        } else {
            // END OF ROWS, hide button
            loadMore.classList.remove('load_more--active');
        }
    }
}

if(section){
    const rows = window['virtualTourRowsJson'];
    const rowsCount = rows.length;
    const loadMore = document.querySelector('#virtual-tour-rows-cta-wrapper');
    
    // if json rows from acf are not empty
    if (rowsCount > 0){
        // manage load more visiblity
        showHideLoadMore(rowsCount);
        // initial page load
        virtualTourRowsHtml(rows);
        // watch load more button
        if(loadMore){
            loadMore.addEventListener("click", (e) => {
                e.preventDefault();
                // increase display count by 2
                rowDisplayCount += rowBankCount;
                // toggle load more visibility
                showHideLoadMore(rowsCount);
                // print new rows
                virtualTourRowsHtml(rows);
            });
        }
    }
}